import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Spinner,
    Pagination,
    PaginationItem,
    PaginationLink,
    Button
} from 'reactstrap';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';
import Header from '../../components/Headers/Header';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaDownload } from 'react-icons/fa';
// import './TeacherSubjectResultPage.css';
import Footer from 'components/Footers/Footer';

const baseURL = apiURL1;

function TeacherSubjectResultPage() {
    const token = localStorage.getItem("token");

    const [teacherId, setTeacherId] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 2;

    useEffect(() => {
        // Retrieve user info from localStorage
        const user = localStorage.getItem('userInfo');
        if (user) {
            try {
                const parsedUser = JSON.parse(user);
                setTeacherId(parsedUser._id);
            } catch (error) {
                console.error('Error parsing user info from localStorage:', error);
                toast.error('Error retrieving Staff ID.');
            }
        } else {
            toast.error('User info not found in localStorage.');
        }
    }, []);

    useEffect(() => {
        if (teacherId) {
            fetchResults();
        }
    }, [teacherId, page]);

    const fetchResults = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseURL}/teacher/getResultsByTeacher/${teacherId}?page=${page}&limit=${itemsPerPage}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            });
            // console.log(' response.data ', response.data.data)
            if (response.data.data.length === 0) {
                toast.warn('No results found.');
                return;

            }
            if (response.data && response.data.data && response.data.success && Array.isArray(response.data.data)) {
                setResults(response.data.data);
                setTotalPages(response.data.pagination.totalPages);
            } else {
                setResults([]);
                setTotalPages(0);
                toast.warn(response.data.message || 'No results found.');
            }
        } catch (error) {
            console.error('Error fetching results:', error);
            toast.error('Error fetching results');
            setResults([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    const generatePdfReport = (result) => {
        const pdf = new jsPDF();
        pdf.setFontSize(18);
        pdf.text(`Subject Result - ${result.subject?.name}`, 10, 10);

        let y = 20;
        pdf.setFontSize(14);
        pdf.text(`Class: ${result.class?.className}`, 10, y);
        y += 10;
        pdf.text(`Subject: ${result.subject?.name}`, 10, y);
        y += 10;
        pdf.text(`Total Marks: ${result.totalMarks}`, 10, y);
        y += 10;
        pdf.text(`Exam Type: ${result?.type?.name}`, 10, y);
        y += 10;
        pdf.text(`Year: ${result.year}`, 10, y);
        y += 10;

        const tableData = result.students.map(student => [
            student?.studentName,
            student.marksObtained,
            student?.grade,
            student.remarks
        ]);

        pdf.autoTable({
            head: [['Name', 'Obtained Marks', 'Grade', 'Remarks']],
            body: tableData,
            startY: y,
        });

        pdf.save(`subject-result-${result.subject.name}.pdf`);
    };

    const renderPagination = () => {
        const paginationItems = [];
        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <PaginationItem key={i} active={i === page}>
                    <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                </PaginationItem>
            );
        }

        return (
            <Pagination style={{ justifyContent: 'center' }}>
                <PaginationItem disabled={page === 1}>
                    <PaginationLink previous onClick={() => setPage(page - 1)} />
                </PaginationItem>
                {paginationItems}
                <PaginationItem disabled={page === totalPages}>
                    <PaginationLink next onClick={() => setPage(page + 1)} />
                </PaginationItem>
            </Pagination>
        );
    };

    return (
        <>
            <Header />
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3>My Subject Results</h3>
                            </CardHeader>
                            <CardBody>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Spinner color="primary" />
                                    </div>
                                ) : results.length > 0 ? (
                                    results.map((result) => (
                                        <Card key={result._id} className="mb-3">
                                            <CardHeader>
                                                <h5>{result.subject?.name} - {result.class?.className} ({result?.type?.name} - {result.year})</h5>
                                            </CardHeader>
                                            <CardBody>
                                                <div className="d-flex justify-content-end mb-2">
                                                    <Button color="success" size="sm" onClick={() => generatePdfReport(result)}>
                                                        <FaDownload /> Download PDF
                                                    </Button>
                                                </div>
                                                <div className="table-responsive">
                                                    <Table className="table">
                                                        <thead>
                                                            <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                                                <th>Name</th>
                                                                <th>Obtained Marks</th>
                                                                <th>Grade</th>
                                                                <th>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {result.students.map(student => (
                                                                <tr key={student?.student?._id || 'N/A'}>
                                                                    <td>{student?.studentName || 'N/A'}</td>
                                                                    <td>{student.marksObtained}</td>
                                                                    <td>{student?.grade || 'N/A'}</td>
                                                                    <td>{student.remarks}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    ))
                                ) : (
                                    <p>No results found.</p>
                                )}
                                {renderPagination()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Footer />
            </Container>
        </>
    );
}

export default TeacherSubjectResultPage;
